import { html } from 'lit';
import { Routes } from '@lit-labs/router';
import { ConnectAccountController } from '../../lib/controllers/connect-account.js';
import { BaseElement } from '../base.js';
import './sidebar.js';
import './status.js';
import './customers.js';
import './integrations.js';
import './uploads.js';
import './products.js';

export class ConnectAccountDetails extends BaseElement {
  static properties = {
    account: {}
  };

  constructor() {
    super();
    this.routes = new Routes(this, [
      {
        path: 'customers',
        render: () => this.renderPage('customers')
      },
      {
        path: 'notifications',
        render: () => this.renderPage('notifications')
      },
      {
        path: 'integrations',
        render: () => this.renderPage('integrations')
      },
      {
        path: 'uploads',
        render: () => this.renderPage('uploads')
      },
      {
        path: 'products',
        render: () => this.renderPage('products')
      },
      {
        path: '*',
        render: () => this.renderPage('status')
      }
    ]);

    this.account = '';
    this.account_loader = new ConnectAccountController(this);
  }

  render() {
    return this.routes.outlet();
  }

  renderPage(tab) {
    return this.account_loader.render((account) => {
      let tab_content;
      switch (tab) {
        case 'customers':
          tab_content = html`
            <connect-account-customers
              account=${account.account}
              .item=${account}
            ></connect-account-customers>
          `;
          break;
        case 'notifications':
          tab_content = html`
            <connect-account-notifications
              .item=${account}
            ></connect-account-notifications>
          `;
          break;
        case 'integrations':
          tab_content = html`
            <connect-account-integrations .item=${account}>
            </connect-account-integrations>
          `;
          break;
        case 'uploads':
          tab_content = html`
            <connect-account-uploads account=${account.account}>
            </connect-account-uploads>
          `;
          break;
        case 'products':
          tab_content = html`
            <connect-account-products account=${account.account}>
            </connect-account-products>
          `;
          break;
        case 'status':
        default:
          tab_content = html`
            <connect-account-status .item=${account}></connect-account-status>
          `;
      }
      return html`
        <div class="row">
          <div class="col-12 col-lg-5 col-xl-4 mb-4">
            <connect-account-sidebar
              .item=${account}
              tab=${tab}
            ></connect-account-sidebar>
          </div>
          <div class="col-12 col-lg-7 col-xl-8">${tab_content}</div>
        </div>
      `;
    });
  }
}

customElements.define('connect-account-details', ConnectAccountDetails);
